import React, { useEffect, useState } from "react";
import { Avatar, Box, createTheme, ThemeProvider } from "@mui/material";
import {
  SidebarContainer,
  SidebarMenuContainer,
  StyledNavLink,
  LogoContainer,
  LogoOut
} from "./SideElement";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck.js";
import HomeIcon from "../../menuIcons/HomeIcon.js";
import LeadIcon from "../../menuIcons/LeadIcon.js";
import DcumentUploadIcon from "../../menuIcons/DcumentUploadIcon.js";
import PartnerIcons from "../../menuIcons/PartnerIcons.js";
import AdministrationIcon from "../../menuIcons/AdministrationIcon.js";
import ApplicationIcon from "../../menuIcons/ApplicationIcon.js";
import UniversityIcon from "../../menuIcons/UniversityIcon.js";
import TicketsIcon from "../../menuIcons/TicketsIcon.js";
import EnquiryIcon from "../../menuIcons/EnquiryIcon.js";
import WebsiteIcon from "../../menuIcons/WebsiteIcon.js";
import IeltsIcon from "../../menuIcons/IeltsIcon.js";
import HrManagement from "../../menuIcons/HrManagement.js";
import AccountsIcon from "../../menuIcons/AccountsIcon.js";
import ReferIcon from "../../menuIcons/ReferIcon.js";
import SettingsIcon from "../../menuIcons/SettingsIcon.js";
import ReportIcon from "../../menuIcons/reportIcon.js";
import DealIcon from "../../menuIcons/dealIcon.js";
import EntrolledIcon from "../../menuIcons/entrolledIcon.js";
const Sidebar = ({ mouseOnEnter, mouseOnLeave, isHover }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isActive, setActive] = useState(null);
  const [items, setItems] = useState([
    "Home",
    "Leads",
    "Deals",
    "Enrolled",
    "Partner Lead",
    "Partner Deals",
    "Partner Enrolled",
    "Document Upload",
    "Partner",
    "Administration",
    "Application",
    "university",
    // "Course",
    "Tickets",
    "Total Search",
    "Website",
    "Ielts",
    "HR Management",
    "Report",
    "Accounts",
    "Refer & Earn",
    "Settings"
  ]);

  const [pages, setPages] = useState([
    "Home",
    "Leads",
    "deals",
    "enrolled",
    "partnerLeadApplication",
    "partnerEntrolledApplication",
    "partnerEntrolled",
    "approval",
    "DocumentUpload",
    "Partner",
    "Administration",
    "Application",
    "university",
    // "Course",
    "Tickets",
    "Total Search",
    "landingPage",
    // privilege?.isIeltsView !== false ? "ielts" : null,
    "Ielts",
    "hrManagment",
    "Accounts",
    "ReferAndEarn",
    "Settings"
  ]);

  let { loginFindLoading, loginFindSuccess, loginFinderror } = useSelector(
    (state) => {
      return state.findUser;
    }
  );

  const { loginSuccess, loginSubmitLoading, loginSubmiterror } = useSelector(
    (state) => {
      return state.loginSubmit;
    }
  );

  // custom Hooks
  const { privilege, hasPrivilege } = usePrivilegeCheck();

  let isUserExist = localStorage.getItem("loginInfo")
    ? JSON.parse(localStorage.getItem("loginInfo"))
    : null;

  // useEffect(() => {
  //   if (loginFindSuccess) {
  //     alert(loginFindSuccess);
  //   }
  // }, [loginFindSuccess]);
  // hooks
  useEffect(() => {
    if (!isUserExist) {
      navigate("/login");
    }
  }, [isUserExist, navigate, privilege, loginFindSuccess, isHover]);

  useEffect(() => {
    if (privilege && privilege !== null) {
      const uniqueNames = new Set(
        privilege?.role_sub_menus?.flatMap((item) =>
          item?.side_menu?.name ? [item.side_menu.name] : []
        )
      );

      setItems([...uniqueNames]);

      const uniquePage = new Set(
        privilege?.role_sub_menus?.flatMap((item) =>
          item?.side_menu?.path ? [item.side_menu.path] : []
        )
      );

      setPages([...uniquePage]);
    } else {
      setItems([
        "Home",
        "Leads",
        "Deals",
        "Enrolled",
        "Partner Lead",
        "Partner Enrolled",
        "Approvals",
        "Document Upload",
        "Partner",
        "Administration",
        "Application",
        "university",
        // "Course",
        "Tickets",
        "Total Search",
        "Website",
        "Ielts",
        "HR Management",
        "Accounts",
        "Report",
        "Refer & Earn",
        "Settings"
      ]);

      setPages([
        "Home",
        "Leads",
        "deals",
        "enrolled",
        "partnerLeadApplication",
        "partnerEntrolledApplication",
        "approval",
        "DocumentUpload",
        "Partner",
        "Administration",
        "Application",
        "University",
        // "Course",
        "Tickets",
        "Total Search",
        "landingPage",
        "Ielts",
        "hrManagment",
        "Accounts",
        "reports",
        "ReferAndEarn",
        "Settings"
      ]);
    }
  }, [privilege, loginFindSuccess, loginSubmitLoading]);

  const toggleClass = (index) => {
    setActive(index);
  };

  // theme Provider
  let theme = createTheme({
    width: "auto",
    palette: {
      primary: {
        main: "#0052cc"
      },
      secondary: {
        main: "#edf2ff"
      }
    }
  });

  theme = createTheme(theme, {
    palette: {
      info: {
        main: theme.palette.secondary.main
      }
    }
  });

  console.log(pages, "pagespagespages");
  console.log(items, "itemsitemsitems");

  return (
    <ThemeProvider theme={theme}>
      {isUserExist ? (
        <SidebarContainer
          act={isHover}
          onMouseEnter={mouseOnEnter}
          onMouseLeave={mouseOnLeave}
          // style={{
          //   minHeight: '732px', // This ensures the sidebar takes full viewport height
          //   height: '200px', 
          //   overflowY: 'auto'     // Automatically expands based on content
          // }}
        >
          <SidebarMenuContainer>
            <Box>
              <LogoContainer act={isHover} id="item" to="/">
                <i className="bx bx-layer nav_logo-icon">
                  <img src="/gsl.svg" alt="gsl" />
                </i>
              </LogoContainer>

              {items.map(function (item, index) {
                var strClass = "";
                if (isActive === index) {
                  strClass = "active";
                } else {
                  strClass = "Noactive";
                }
                if (item !== null)
                  return (
                    <StyledNavLink
                      to={"/" + pages[index]}
                      className={strClass}
                      key={index}
                      onClick={() => toggleClass(index)}
                    >
                      {item == "Home" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                stroke:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <HomeIcon />
                          </Box>
                        </i>
                      )}
                      {item == "Leads" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <LeadIcon />
                          </Box>
                          {/* <img
                            style={{ width: "20px" }}
                            src="/menuIcons/lead.svg"
                            alt="gsl"
                          /> */}
                        </i>
                      )}

                      {item == "Deals" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <DealIcon />
                          </Box>
                          {/* <img
                            style={{ width: "20px" }}
                            src="/menuIcons/lead.svg"
                            alt="gsl"
                          /> */}
                        </i>
                      )}

                      {item == "Enrolled" || item == "Entrolled" ? (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <EntrolledIcon />
                          </Box>
                        </i>
                      ) : (
                        ""
                      )}

                      {item == "Patner Lead" || item == "Partner Lead" ? (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <LeadIcon />
                          </Box>
                        </i>
                      ) : (
                        ""
                      )}

                      {item == "Partner Deal" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <DealIcon />
                          </Box>
                        </i>
                      )}

                      {item == "Partner Enrolled" ||
                      item == "Partner Entrolled" ? (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <EntrolledIcon />
                          </Box>
                        </i>
                      ) : (
                        ""
                      )}

                      {item == "Approvals" || item == "Approval" ? (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <DealIcon />
                          </Box>
                        </i>
                      ) : (
                        ""
                      )}

                      {item == "Document Upload" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <DcumentUploadIcon />
                          </Box>
                        </i>
                      )}

                      {item == "Partner" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <PartnerIcons />
                          </Box>
                        </i>
                      )}

                      {item == "Administration" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                stroke:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <AdministrationIcon />
                          </Box>
                        </i>
                      )}

                      {item == "Application" && (
                        <i>
                          <Box
                            sx={{
                              "& svg  path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <ApplicationIcon />
                          </Box>
                        </i>
                      )}

                      {item == "university" && (
                        <i>
                          <Box
                            sx={{
                              "& svg  path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <UniversityIcon />
                          </Box>
                        </i>
                      )}

                      {item == "Course" && (
                        <i>
                          <img
                            style={{ width: "20px" }}
                            src="/menuIcons/course.svg"
                            alt="gsl"
                          />
                        </i>
                      )}

                      {item == "Tickets" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <TicketsIcon />
                          </Box>
                        </i>
                      )}

                      {item == "Total Search" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <EnquiryIcon />
                          </Box>
                        </i>
                      )}

                      {item == "Website" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <WebsiteIcon />
                          </Box>
                        </i>
                      )}

                      {item === "IELTS" || item === "Ielts" ? (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <IeltsIcon />
                          </Box>
                        </i>
                      ) : (
                        ""
                      )}

                      {item == "HR Management" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <HrManagement />
                          </Box>
                        </i>
                      )}

                      {item == "Accounts" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <AccountsIcon />
                          </Box>
                        </i>
                      )}

                      {item == "Report" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                stroke:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <ReportIcon />
                          </Box>
                        </i>
                      )}

                      {item == "refer&earn" || item == "Refer & Earn" ? (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                stroke:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <ReferIcon />
                          </Box>
                        </i>
                      ) : (
                        ""
                      )}

                      {item == "Settings" && (
                        <i>
                          <Box
                            sx={{
                              "& svg path": {
                                fill:
                                  strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                              }
                            }}
                          >
                            <SettingsIcon />
                          </Box>
                        </i>
                      )}

                      {!isHover && (
                        <span
                          style={{
                            fontSize: "15px",
                            fontWeight: 500,
                            color: strClass === "active" ? "#FF1B6F" : "#ACB1C6"
                          }}
                        >
                          {item}
                        </span>
                      )}
                    </StyledNavLink>
                  );
              })}
            </Box>
            <LogoOut>
              {/* <i className="bx bx-bookmark nav_icon" />
              <Avatar
                alt="GSL"
                src="/static/images/avatar/1.jpg"
                sx={{ width: 56, height: 56 }}
              /> */}
            </LogoOut>
          </SidebarMenuContainer>
        </SidebarContainer>
      ) : null}
    </ThemeProvider>
  );
};
export default Sidebar;
